import { ClientNotificationSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GetNotificationAlertsResponseSchema = oz.array(ClientNotificationSchema).openapi('GetNotificationAlertsResponseSchema');

export type GetNotificationAlertsResponse = oz.TypeOf<typeof GetNotificationAlertsResponseSchema>;